import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { updateCurrentTopic } from "../store/actions";

export const useClearCurrentTopic = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateCurrentTopic(null));
  }, [dispatch]);
};
